import { apiInstance } from "redux/axiosApi";
import { AUTH_LOGOUT } from "./constAPI";

export const backendLogout = async (): Promise<void> => {
  try {
    await apiInstance.post(AUTH_LOGOUT);
  } catch (error) {
    console.error("Backend logout failed:", error);
  }
};
